import { useSearchParams } from "react-router-dom";
import { useSession } from "@core/session/SessionProvider";
import { tokens } from "@core/theme/tokens";
import { SegmentedControl } from "@portal/common";
import { MemberRulesPanel } from "./MemberRulesPanel";
import { ReferralRulesPanel } from "./ReferralRulesPanel";

// RUTEO decidido por el humano (prompt de despacho, 2026-09-07): una sola
// ruta /points-engine que monta esta pantalla con el `SegmentedControl`
// interno del prototipo (admin.jsx:3308-3319, `AdminMotorPuntos`). El
// segmento activo persiste en la URL como `?view=member|referral` para que
// `design-reviewer` y el spec visual capturen los dos estados default de
// forma reproducible — las rutas `/portal/points-member` y
// `/portal/points-referral` de `screens.json` son metadatos del contrato
// visual, no requisito de ruteo.
const VIEWS = [
  { value: "member", label: "Acciones del miembro" },
  { value: "referral", label: "Acciones del referido" },
] as const;
type View = (typeof VIEWS)[number]["value"];

export function PointsEngineScreen() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { hasPermission } = useSession();
  const view: View =
    searchParams.get("view") === "referral" ? "referral" : "member";

  const canCreate = hasPermission("points_engine", "canCreate");
  const canEdit = hasPermission("points_engine", "canEdit");

  return (
    <div>
      <header style={{ marginBottom: 20 }}>
        <h1
          className="display"
          style={{
            margin: 0,
            font: `400 34px/1.06 ${tokens.font.display}`,
            color: tokens.text.primary,
          }}
        >
          Motor de Puntos
        </h1>
        <p
          style={{
            margin: "6px 0 0",
            font: `400 13px ${tokens.font.ui}`,
            color: tokens.text.tertiary,
          }}
        >
          Reglas de otorgamiento de puntos por cada acción del miembro.
        </p>
        <div style={{ marginTop: 26 }}>
          <SegmentedControl
            label="Motor de Puntos"
            options={VIEWS.map((entry) => ({
              value: entry.value,
              label: entry.label,
            }))}
            activeValue={view}
            onSelect={(value) => setSearchParams({ view: value })}
          />
        </div>
      </header>
      {view === "member" ? (
        <MemberRulesPanel canCreate={canCreate} canEdit={canEdit} />
      ) : (
        <ReferralRulesPanel canCreate={canCreate} canEdit={canEdit} />
      )}
    </div>
  );
}
